export default __webpack_public_path__ + "static/media/cross_icon_link.deacddf6.svg";